<template>
  <Dialog scrollable :common-dialog="visitDialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout v-if="visitDialog">
        <v-flex md12 class="d-flex">
          <h1
            class="form-title custom-nowrap-ellipsis text-capitalize mb-0 cursor-pointer"
            v-on:click="routeDetail"
          >
            Tool #{{ toolDetail?.tool_relation?.barcode }}
          </h1>

          <v-chip
            :color="getToolStatusColor(toolDetail.tool_relation.status_value)"
            label
            text-color="white"
            class="mr-2 ml-2"
            v-if="toolDetail?.tool_relation?.status_value"
          >
            {{ toolDetail.tool_relation.status_value }}
          </v-chip>

         <!--  <v-chip
            :color="getToolStatusColor('Faulty')"
            label
            outlined
            text-color=""
            class="mr-2"
            v-if="toolDetail?.tool_relation?.faulty"
          >
            Faulty
          </v-chip>
          <v-chip
            :color="getToolStatusColor('Retired')"
            label
            text-color=""
            outlined
            class="mr-2"
            v-if="toolDetail?.tool_relation?.retired"
          >
            Retired
          </v-chip> -->
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="ml-2 custom-grey-border custom-bold-button"
            v-on:click="$emit('close', true)"
          >
            Close
          </v-btn>
        </v-flex>
      </v-layout>
    </template>

    <template v-slot:body>
      <v-container>
        <v-row>
          <v-col cols="5" class="pb-0">
            <BasicOverview :detail="toolDetail.tool_relation"></BasicOverview>
          </v-col>
          <v-col md="7" class="pb-0 gray-background pl-4">
            <v-container fluid>
              <v-row dense>
                <v-col md="12">
                  <v-skeleton-loader
                    class="custom-skeleton height-30px mr-2 my-auto custom-skeleton-full-width"
                    width="100"
                    type="text"
                    v-if="pageLoading"
                  >
                  </v-skeleton-loader>

                  <h1
                    v-else
                    class="form-title custom-nowrap-ellipsis text-uppercase" style="color: #24326d !important;"
                  >
                     Visit Information
                  </h1>
                  <v-skeleton-loader
                    class="custom-skeleton height-30px mr-2 my-auto custom-skeleton-full-width"
                    width="100"
                    type="text"
                    v-if="pageLoading"
                  >
                  </v-skeleton-loader>
                  <v-chip
                    v-else
                    class="my-2 font-weight-600"
                    color="chip-custom-blue text-capitalize"
                    label
                    outlined
                  >
                    {{ toolDetail?.visit_relation?.btx_schedule_type }}
                  </v-chip>
                    <v-chip
                        class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                        :color="getStatusColor(toolDetail?.visit_relation?.status)"
                        label
                        :text-color="
                          toolDetail?.visit_relation?.status == 2 ? 'black' : 'white'
                        "
                      >
                        {{ toolDetail.visit_status_text }}
                      </v-chip>
                  <template v-if="pageLoading">
                    <v-skeleton-loader
                      v-for="(d, i) in 2"
                      :key="i"
                      class="custom-skeleton height-40px custom-skeleton-full-width mr-5"
                      :class="{ 'mt-3': i <= 0, 'my-1': i > 0 }"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <table class="width-100">
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Visit Number
                        </td>

                        <td class="font-weight-600 font-size-18 py-1">
                          <template>
                            <router-link
                              :to="{
                                name: 'admin.visit.detail',
                                params: {
                                  id: toolDetail?.visit_relation?.id,
                                },
                              }"
                              target="_blank"
                            >
                              <Barcode
                                dense
                                :barcode="
                                  toolDetail?.visit_relation?.trip_barcode
                                "
                              ></Barcode>
                            </router-link>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Appointment
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span style="color: #24326d !important">
                            {{ getAppointmentText }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="200">
                          Technicians
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span
                            v-if="
                              toolDetail?.visit_relation
                                ?.assigned_engineers
                            "
                          >
                            <v-chip
                              style="height: 26px"
                              v-for="(row, index) in toolDetail?.visit_relation.assigned_engineers"
                              :key="index"
                              class="mx-2"
                              color="cyan white--text"
                              label
                            >
                              <v-icon small left> mdi-account-circle </v-icon>
                              {{ row }}
                            </v-chip>
                          </span>
                           <em class="text-muted" v-else> No Technicians</em>
                        </td>
                      </tr>
                     <!--  <tr>
                        <td class="font-size-18 py-1 d-flex" width="200">
                          <b> Service Report PDF</b>
                        </td>
                        <td class="font-weight-600 font-size-18 py-1">
                        
                          <span
                            v-if="
                              toolDetail?.visit_relation
                                ?.service_form?.length > 0
                            "
                          >
                            <v-tooltip
                              top
                              content-class="custom-top-tooltip"
                              v-for="(form, index) in toolDetail
                                ?.visit_relation?.service_form"
                              :key="index"
                            >
                            {{form}}
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :disabled="form?.view_pdf_url ? false : true"
                                  :color="
                                    form.is_filled == 0
                                      ? '#d3be09'
                                      : form.need_cost == 1
                                      ? 'black'
                                      : 'red'
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mx-2 custom-bold-button white--text mb-1"
                                  v-on:click.stop.prevent="
                                    downloadFile(form.view_pdf_url)
                                  "
                                >
                                  <v-icon left>mdi-file-pdf</v-icon>
                                  {{ getBarcode(form) }}
                                </v-btn>
                              </template>
                              <span>{{ form.title }}</span>
                            </v-tooltip>
                          </span>
                          <em class="text-muted" v-else> No Service Report</em>
                        </td>
                      </tr> -->
                    </table>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </Dialog>
</template>

<script>
import BasicOverview from "@/view/pages/equipment/detail/BasicOverview";
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { GET } from "@/core/services/store/request.module";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin],
  props: {
    visitDialog: {
      type: Boolean,
      default: false,
    },
    isCalendar: {
      type: Boolean,
      default: false,
    },
    assignedTool: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: null,
    },
  },
  watch: {
    assignedTool: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.loadContent();
        }
      },
    },
  },
  data() {
    return {
      pageLoading: false,
      detail: new Object(),
      toolDetail: {},
      timeInterval: null,
      durationInterval: null,
    };
  },
  methods: {
    getBarcode(service) {
      let barcodeStr =
        this.toolDetail?.tool_relation?.visit_relation?.barcode.split("-");
      barcodeStr = barcodeStr[0];
      let perent =
        this.toolDetail?.tool_relation?.visit_relation?.barcode.replace(
          barcodeStr,
          "SRV"
        );
      return perent + "-" + service.service_barcode;
    },
    getToolStatusColor(status = "") {
      let color = "cyan";
      switch (status) {
        case "Active":
          color = "green";
          break;
        case "In-Active":
          color = "red";
          break;
        case "Faulty":
          color = "orange";
          break;
        case "Retired":
          color = "red";
          break;
      }
      return color;
    },

    routeDetail() {
      this.$router.push(
        this.getDefaultRoute("equipment.detail", {
          params: {
            id: this.toolDetail?.tool_relation?.id ?? undefined,
          },
        })
      );
    },

    loadContent() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "assigned/tool/" + _this.assignedTool,
        })
        .then(({ data }) => {
          _this.toolDetail = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  components: {
    Dialog,
    Barcode,
    BasicOverview,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 70);
    },

    getAppointmentText() {
      if (this.lodash.isEmpty(this.toolDetail?.visit_relation) === false) {
        let date = this.formatDate(this.toolDetail?.visit_relation?.started_at);
        let startTime = moment(
          this.toolDetail?.visit_relation?.started_at
        ).format("hh:mm A");
        let enddate = this.formatDate(
          this.toolDetail?.visit_relation?.finished_at
        );
        let endTime = moment(
          this.toolDetail?.visit_relation?.finished_at
        ).format("hh:mm A");
        return `${date} ${startTime} - ${enddate} ${endTime}`;
      }
      return null;
    },
  },
};
</script>
